module.exports = __webpack_public_path__ + "media/images/gallery/constellations/auriga/aur_vis-b8b38985b85f188cca22591a7e68c0af.jpg";